import SelectMenu from "../../../controls/SelectMenu";

export default function QaReceivingOptions(props) {
  const { filters, setFilters, suppliers, categories, products } = props;
  return (
    <div className="grid grid-cols-6 gap-3">
      <SelectMenu
        title="Supplier"
        handleInputChange={(e) =>
          setFilters({ ...filters, supplier: e.target.value })
        }
        name="supplier"
        options={suppliers}
        value={filters.supplier}
      />
      <SelectMenu
        title="Category"
        handleInputChange={(e) =>
          setFilters({ ...filters, category: e.target.value })
        }
        name="category"
        options={categories}
        value={filters.category}
      />
      <SelectMenu
        title="Product"
        handleInputChange={(e) =>
          setFilters({ ...filters, product: e.target.value })
        }
        name="product"
        options={products}
        value={filters.product}
      />
    </div>
  );
}
